import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { ReactComponent as AIIcon } from "../../../assets/svg/AI-icon.svg";
import "./AIModal.scss";
import { useSelector } from "react-redux";

const DraggableAIIcon = ({ handleModal }) => {
    const [isDragging, setIsDragging] = useState(false);
    const [values, setValues] = useState({});
    const sidebarExpanded = useSelector((state) => state.globalReducer.sidebarExpanded);

    const calculateDraggableBounds = () => {
        const sidebarWidth = sidebarExpanded ? 240 : 50;

        return {
            left: -window.innerWidth + sidebarWidth + 75,
            top: -window.innerHeight + 54 + 120,
            right: 0,
            bottom: 50,
        };
    };

    const handleDragStart = (e, data) => {
        setIsDragging(true);
        setValues({ xValue: data.x, yValue: data.y });
    };

    const handleDragStop = (e, data) => {
        setIsDragging(false);
        if (!(values.xValue === data.x && values.yValue === data.y)) {
            handleModal();
        } else {
            setValues({ xValue: data.x, yValue: data.y });
        }
    };

    const draggableBounds = calculateDraggableBounds();
    return (
        <Draggable bounds={draggableBounds} onStart={handleDragStart} onStop={handleDragStop}>
            <div
                onClick={() => {
                    handleModal();
                }}
                className={`draggable-icon ${isDragging ? "dragging" : ""}`}>
                <AIIcon />
            </div>
        </Draggable>
    );
};

export default DraggableAIIcon;
